import common from './common'
import style from './style'
import date from './date'
import exportExcel from './export'

const tools = {
  common: common,
  style: style,
  date: date,
  exportExcel:exportExcel
}
export default tools


// WEBPACK FOOTER //
// ./src/tools/index.js